<script setup lang="ts">
interface Props {
  anchor?: string
}

defineProps<Props>()
</script>

<template>
  <span
    v-if="anchor"
    :id="anchor"
  />
</template>
